import { Navigate } from "react-router-dom";
import { useFeatureFlag } from "eligibility/hooks/useFeatureFlag";
import { EligibilityChecker } from "./EligibilityChecker";

// Feature-flag gate for the route (alongside the RBAC <ProtectedRoute>). When the
// tenant flag is off, the route redirects — the API also enforces the flag.
export const EligibilityCheckerRoute = () => {
  const enabled = useFeatureFlag("eligibility_checker");
  if (!enabled) return <Navigate to="../dashboard" replace />;
  return <EligibilityChecker />;
};

export default EligibilityCheckerRoute;
